var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareBlackMenu = function SvgShareBlackMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "share-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-share-1037331",
    d: "M13.337 0a3.018 3.018 0 0 0-3.012 3.012 2.978 2.978 0 0 0 .175.995l-5.512 3.2a3.009 3.009 0 1 0 .007 4.518l5.506 3.193a2.981 2.981 0 0 0-.175 1 3.021 3.021 0 1 0 .578-1.768L5.56 11.058a2.981 2.981 0 0 0 0-3.193l5.345-3.092A3.008 3.008 0 1 0 13.338 0Z"
  })));
};
export default SvgShareBlackMenu;